/**
 * Wiederverwendbare Kartenkomponente für Optionsauswahl
 * Wird in allen Wizard-Steps für konsistentes Styling verwendet
 */
export default function OptionCard({
  isSelected,
  onClick,
  icon: Icon,
  label,
  description,
  price,
  extra,
  className = "",
  badge,
  size = "base", // base, sm
}) {
  const sizeClasses = {
    base: "p-6 rounded-xl",
    sm: "p-4 rounded-lg",
  };

  const gapClasses = {
    base: "gap-3",
    sm: "gap-2",
  };

  const labelSizeClasses = {
    base: "text-base",
    sm: "text-sm",
  };

  const descriptionSizeClasses = {
    base: "text-sm",
    sm: "text-xs",
  };

  return (
    <button
      onClick={onClick}
      className={`border-2 transition-all text-left ${sizeClasses[size]} ${
        isSelected
          ? "border-[#FF5744] bg-[#FFF4F0]"
          : "border-slate-200 bg-white hover:border-slate-300"
      } ${badge ? "relative" : ""} ${className}`.trim()}
    >
      {badge && (
        <span className="absolute -top-2 -right-2 text-[10px] uppercase tracking-wide font-semibold bg-[#FF5744] text-white px-2 py-0.5 rounded-full">
          {badge}
        </span>
      )}
      <div className={`flex items-start ${gapClasses[size]}`}>
        {Icon && <Icon className="h-6 w-6 text-slate-600 flex-shrink-0 mt-1" />}
        <div className="flex-1">
          <h3
            className={`font-bold text-slate-900 mb-1 ${labelSizeClasses[size]}`}
          >
            {label}
          </h3>
          {description && (
            <p className={`text-slate-600 ${descriptionSizeClasses[size]}`}>
              {description}
            </p>
          )}
          {price && price}
          {extra && <div className="mt-2">{extra}</div>}
        </div>
      </div>
    </button>
  );
}
